const AnalyticsRebuildModal = ({
  isOpen,
  scope,
  submitting = false,
  errorMessage = "",
  onClose,
  onConfirm,
}) => {
  if (!isOpen || !scope) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/35 px-4">
      <div className="w-full max-w-lg rounded-3xl bg-white p-6 shadow-2xl">
        <div className="mb-5">
          <div className="mb-3 inline-flex rounded-full bg-zinc-100 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-zinc-600">
            Admin Action
          </div>
          <h3 className="text-xl font-semibold text-zinc-900">{scope.title}</h3>
          <p className="mt-2 text-sm leading-6 text-zinc-600">
            This recalculates persisted monthly analytics from successful
            payments only, using
            <span className="mx-1 rounded bg-zinc-100 px-1.5 py-0.5 font-mono text-[11px] text-zinc-700">
              payment_month
            </span>
            as the reporting bucket.
          </p>
        </div>

        <div className="rounded-2xl border border-zinc-200 bg-zinc-50 px-4 py-4">
          <div className="text-xs font-semibold uppercase tracking-wide text-zinc-500">
            Rebuild Scope
          </div>
          <div className="mt-1 text-sm font-medium text-zinc-900">
            {scope.rangeLabel}
          </div>
          <p className="mt-2 text-sm text-zinc-600">{scope.description}</p>
        </div>

        {errorMessage ? (
          <div className="mt-4 rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
            {errorMessage}
          </div>
        ) : null}

        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onClose}
            disabled={submitting}
            className="rounded-xl border border-zinc-200 px-4 py-2 text-sm font-medium text-zinc-700 transition hover:bg-zinc-50 disabled:cursor-not-allowed disabled:opacity-60"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={submitting}
            className="inline-flex items-center justify-center rounded-xl bg-zinc-900 px-4 py-2 text-sm font-medium text-white transition hover:bg-zinc-800 disabled:cursor-not-allowed disabled:opacity-70"
          >
            {submitting ? "Rebuilding..." : scope.confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsRebuildModal;
